// Categories
export const ALLIANCE_DOCUMENTS_CATEGORY = 0;
export const PRODUCT_DOCUMENTS_CATEGORY = 1;

// Document Types
export const REQUEST_FORM_TYPE = 0;
export const DOCUMENTS_TYPE = 1;
export const CONTRACT_TYPE = 2;
export const PRIVATE_DOCUMENTS_TYPE = 3;
export const INSURANCE_DOCUMENTS_TYPE = 4;
export const FILE_FOR_DOCUMENT_TYPES = [
    CONTRACT_TYPE,
    INSURANCE_DOCUMENTS_TYPE,
    REQUEST_FORM_TYPE,
];

// Product Types
export const SIMPLE_TYPE = 0;
export const FILE_COMPLEX_TYPE = 1;
export const FILE_SIMPLE_TYPE = 2;
export const INFONAVIT_TYPE = 3;
export const INSURANCE_TYPE = 4;

export const DEBOUNCE_TIME_1500 = 1500;
export const DEBOUNCE_TIME_500 = 500;
export const INFINITY = 100000000;
export const MAX_FILE_SIZE = 52428800;

export const CAN_CREATE = 4;
export const CAN_UPDATE = 2;
export const CAN_DELETE = 1;

export const DEFAULT_ALGORITHM_TYPES = [
    { label: 'Crédito Simple', value: 'static_payment' },
    { label: 'Arrendamiento financiero', value: 'static_payment_tax' },
];

export const DEFAULT_PRODUCT_TYPES = [
    { label: 'Público', value: 'public' },
    { label: 'Especial', value: 'special' },
];

export const DEFAULT_RATES = [
    { label: '1', value: '1' },
    { label: '1A', value: '1A' },
    { label: '1B', value: '1B' },
    { label: '1C', value: '1C' },
    { label: '1D', value: '1D' },
    { label: '1E', value: '1E' },
    { label: '1F', value: '1F' },
    { label: 'APBT', value: 'APBT' },
    { label: 'APMT', value: 'APMT' },
    { label: 'DAC', value: 'DAC' },
    { label: 'DIST', value: 'DIST' },
    { label: 'DIT', value: 'DIT' },
    { label: 'GDBT', value: 'GDBT' },
    { label: 'GDMTH', value: 'GDMTH' },
    { label: 'GDMTO', value: 'GDMTO' },
    { label: 'PDBT', value: 'PDBT' },
    { label: 'RABT', value: 'RABT' },
    { label: 'RAMT', value: 'RAMT' },
];

export const DEFAULT_TERMS = [
    { label: '6', value: '6' },
    { label: '12', value: '12' },
    { label: '18', value: '18' },
    { label: '24', value: '24' },
    { label: '36', value: '36' },
    { label: '48', value: '48' },
    { label: '60', value: '60' },
    { label: '72', value: '72' },
    { label: '84', value: '84' },
    { label: '96', value: '96' },
    { label: '108', value: '108' },
    { label: '120', value: '120' },
    { label: '132', value: '132' },
    { label: '144', value: '144' },
    { label: '180', value: '180' },
    { label: '240', value: '240' },
];

export const DEFAULT_TYPES_BUSINESS = [
    { label: 'Persona física', value: 'physical_person' },
    {
        label: 'Persona física con actividad',
        value: 'person_company',
    },
    { label: 'Persona moral', value: 'company' },
];

// Status
export const APPROVED_STATUS = 'Aprobado';
export const CANCELLED_STATUS = 'Cancelado';
export const CLOSED_STATUS = 'Cerrado';
export const CONDITIONED_APPROVED_STATUS = 'Aprobado condicionado';
export const GRANTED_STATUS = 'Otorgado';
export const INCOMPLETE_STATUS = 'Incompleto';
export const NO_DOCUMENT_STATUS = 'Sin documento';
export const PREAPPROVED_STATUS = 'Preaprobado';
export const PROCESS_STATUS = 'Proceso';
export const QUOTED_STATUS = 'Cotizado';
export const REJECTED_STATUS = 'Rechazado';
export const REQUESTED_STATUS = 'Solicitado';
export const DOWNLOAD_STATUS = 'Descargar';

// Status text
export const ENABLED_STATUS = 'Habilitado';
export const PREVIABILITY_STATUS = 'Pre-viabilidad';
export const PRE_APPROVED_STATUS = 'Pre-aprobado';

export const DOCUMENT_STATUS = {
    APPROVED_STATUS: { key: 'Approved', value: 'Aprobado', color: '#54c461' },
    DOWNLOAD_STATUS: { key: 'Download', value: 'Download' },
    INPROCESS_STATUS: { key: 'Process', value: 'Proceso', color: '#1a5459' },
    NO_DOCUMENT_STATUS: {
        key: 'No document',
        value: 'Adjuntar',
    },
    REJECTED_STATUS: { key: 'Rejected', value: 'Rechazado', color: '#d24649' },
    REQUESTED_STATUS: {
        key: 'Requested',
        value: 'Solicitado',
        color: '#fc983a',
    },
};

export const BUREAU_STATUS = {
    NOT_AUTHORIZED: { key: 'not_authorized', value: 'Not authorized' },
    NOT_FOUND: { key: 'not_found', value: 'Not found' },
    PASSED: { key: 'passed', value: 'Passed' },
    PENDING_CLARIFICATION: {
        key: 'pending_clarification',
        value: 'Pending clarification',
    },
    REFUSED: { key: 'refused', value: 'Rejected' },
    REQUESTED: { key: 'requested', value: 'Requested' },
};

export const DEFAULT_LAT = 19.43258226220417;
export const DEFAULT_LNG = -99.13319580978921;
export const DEFAULT_MAP_PREVIEW_ZOOM = 12;

export const FILE_ALLOWED_EXTENSIONS = {
    CSV: '.csv,text/csv,application/vnd.ms-excel',
    IMAGE: 'image/png,image/jpeg,image/jpg',
    PDF: '.pdf,application/pdf',
    XML: '.xml,text/xml',
};

export const MAX_SMALL_FILE_SIZE = 2097152;

export const HIIDDEN_FOOTER_ROUTES = [
    '/funnel',
    '/preview/:uid',
    '/templates/edition',
    '/templates/interactive',
    '/credits/:creditId/preview/:uid',
];

export const URL_TYPES = {
    WISE: 1,
    SUNWISE: 0,
    ZAP: 2,
};

export const DAYS_IN_WEEK = 7;
export const DAYS_IN_YEAR = 365;
export const HOURS_IN_DAY = 24;
export const HOURS_IN_YEAR = 8760;
export const MONTHS_IN_YEAR = 12;
export const MS_IN_HOUR = 3600 * 1000;
export const MS_IN_DAY = MS_IN_HOUR * HOURS_IN_DAY;

export const BRIGHT_UID = 'cb6c91b7-e955-48b2-9fb0-3c1292701b63';
export const CREDIPLATA_UID = '98891ea8-a9bf-47cd-b370-8ab876279f29';
export const DEMO_UID = '9e2ccd9b-f4cb-421e-8063-af50a2401161';
export const ENERGIA_REAL_UID = 'ca4000c4-bf44-4b88-a539-ca25a417bbd0';
export const KAM_UID = 'ec74918b-98fc-4866-863a-7e6267a7bdb0';
export const RED_GIRASOL_UID = '29faa9e1-48ea-4696-ae25-07f7327478fc';
export const SERFIMEX_UID = '1c17991f-e30e-4d7e-ae5b-e01bcccfd83e';

export const DEFAULT_CURRENCY = {
    abbreviation: 'USD',
    locale: 'en-US',
    iso: 'USD',
    name: 'Dolar',
    symbol: '$',
};

// GENERATION
export const MAX_DEGRADATION = 1;
export const GENERATION_SOURCES = {
    NASA: 0,
    CSV: 1,
    DESIGNER: 2,
};

// BATERIES
export const BATTERY_STATUS = { CHARGING: 1, DISCHARGING: 2, IDLE: 0 };

export const BATTERY_OPERATION_STRATEGY = { MAX_POWER: 0, OPTIMAL: 1 };

export const SHARED_OPTIONS = [
    'copy',
    'whatsapp',
    'telegram',
    'mail',
    'facebook',
    'twitter',
    'linkedin',
];

export const CHART_COLORS = [
    '#02E675',
    '#ff9a00',
    '#2F4DFF',
    '#803909',
    '#785F9D',
    '#FA6968',
    '#0073d0',
    '#600980',
    '#002438',
];

export const ENERGY_CHART_COLORS = [
    '#20c4d9',
    '#8bc34a',
    '#ff9a00',
    '#FF590D',
    '#BFBBBD',
    '#ff9a00',
    '#E91E63',
    '#FF0000',
    '#785F9D',
    '#FF4081',
    '#ae6afc',
    '#FC6ADC',
];

//DATES
export const DAYS_NAMES = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];

export const HOURS = [
    '12am',
    '1am',
    '2am',
    '3am',
    '4am',
    '5am',
    '6am',
    '7am',
    '8am',
    '9am',
    '10am',
    '11am',
    '12pm',
    '1pm',
    '2pm',
    '3pm',
    '4pm',
    '5pm',
    '6pm',
    '7pm',
    '8pm',
    '9pm',
    '10pm',
    '11pm',
];

export const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

export const DEBOUNCE_TIME_300 = 300;
export const DEBOUNCE_TIME_1000 = 1000;

export const TABLE_PAGE_SIZE_OPTIONS = [25, 50, 75, 100];
